import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule, MatSnackBarModule,
} from '@angular/material';
import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TextMaskModule } from 'angular2-text-mask';
import { ServicesModule } from '../../services/services.module';
import { SharedModule } from '../../shared/shared.module';
import { IntegrationListComponent } from './integration-list/integration-list.component';
import { IntegrationSetupCredentialsComponent } from './integration-setup-credentials/integration-setup-credentials.component';
import { IntegrationSetupDialogComponent } from './integration-setup-dialog/integration-setup-dialog.component';
import { IntegrationSetupDownloadComponent } from './integration-setup-download/integration-setup-download.component';
import { IntegrationSetupPropertiesComponent } from './integration-setup-properties/integration-setup-properties.component';
import { IntegrationSetupSelectProviderComponent } from './integration-setup-select-provider/integration-setup-select-provider.component';
import { IntegrationSetupWatchVideoComponent } from './integration-setup-watch-video/integration-setup-watch-video.component';
import {
  IntegrationSetupIntroductionDialogComponent
} from './integration-setup-introduction-dialog/integration-setup-introduction-dialog.component';
import {
  IntegrationSetupDisplayApiTokenComponent
} from './integration-setup-display-api-token/integration-setup-display-api-token.component';

@NgModule({
  declarations: [
    IntegrationListComponent,
    IntegrationSetupDialogComponent,
    IntegrationSetupSelectProviderComponent,
    IntegrationSetupDownloadComponent,
    IntegrationSetupWatchVideoComponent,
    IntegrationSetupCredentialsComponent,
    IntegrationSetupPropertiesComponent,
    IntegrationSetupIntroductionDialogComponent,
    IntegrationSetupDisplayApiTokenComponent,
  ],
  entryComponents: [
    IntegrationListComponent,
    IntegrationSetupDialogComponent,
    IntegrationSetupIntroductionDialogComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    ServicesModule,
    SharedModule,
    TextMaskModule,

    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSnackBarModule,
  ],
})
export class IntegrationModule { }

try {
  angular.module('mandaeApp')
    .directive('appProfileIntegration', downgradeComponent({ component: IntegrationListComponent }));
} catch (e) {}
